module.exports = __webpack_public_path__ + "static/media/peterArt10.47267097.jpg";